import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import mfa from "../../Assets/Projects/mfa.png";
import traffic from "../../Assets/Projects/traffic.png";
import chatbot from "../../Assets/Projects/chatbot.png";
import nasa from "../../Assets/Projects/nasa.png";
import cloudflareDNS from "../../Assets/Projects/cloudflareDNS.png";
import portfolio from "../../Assets/Projects/portfolio.png";

//import Chat from "../Chat.js";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={mfa}
              isBlog={false}
              title="MFA Bypass"
              description="Successfully managed to execute a project focusing on Multi-Factor Authentication (MFA) bypass using a reverse proxy. This endeavor included spear phishing tactics and involved bypassing Microsoft O365 Federated SSO secured with Cisco DUO MFA. Additionally, custom phishlets were developed in YAML for various systems, including Deakin-ADFS and GitHub. The project sheds light on the evolving landscape of cybersecurity threats and techniques, underscoring the need for vigilance and innovation in safeguarding digital assets."
              ghLink="https://youtu.be/dQw4w9WgXcQ?si=QLXZoVwZeIVbZq_p"
              demoLink="https://youtu.be/B-PbKxxvwkw"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={traffic}
              isBlog={false}
              title="Identifying Malicious Encrypted Traffic using Machine Learning"
              description="Developed a cutting-edge solution for identifying and mitigating malicious encrypted traffic using machine learning algorithms. This project enhances network security by detecting potential threats that may go unnoticed with traditional methods."
              ghLink="https://youtu.be/dQw4w9WgXcQ?si=QLXZoVwZeIVbZq_p"
              demoLink="https://youtu.be/B-PbKxxvwkw"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatbot}
              isBlog={false}
              title="AI-Chatbot"
              description="Created and deployed an AI-powered chatbot using Python and a custom GPT-3.5-Turbo model. The chatbot serves as a sales assistant for small to medium-sized companies, providing valuable customer support and information retrieval capabilities."
              ghLink="https://youtu.be/dQw4w9WgXcQ?si=QLXZoVwZeIVbZq_p"
              demoLink="https://youtu.be/SEbT2zYntqw"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={nasa}
              isBlog={false}
              title="Network Protocol Fuzzing for Deep Space Communication"
              description="Led a team at Deakin University in a NASA protocol exploits project, focusing on developing and deploying network protocol fuzzing programs for deep space telecommunication networks. Specifically, programs were created to fuzz the Bundle Protocol and Licklider Transmission Protocol, enhancing the security of the Interplanetary Overlay Network."
              ghLink="https://youtu.be/dQw4w9WgXcQ?si=QLXZoVwZeIVbZq_p"
              demoLink="https://youtu.be/B-PbKxxvwkw"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cloudflareDNS}
              isBlog={false}
              title="CloudFlare-DNS-Wizard"
              description="Cloudflare DNS Wizard is a Python script that simplifies the management of DNS records on the Cloudflare platform right inside the linux terminal. With this tool, you can effortlessly fetch and update DNS records, view zone and account information, and optimize your DNS management. Ideal for cybersecurity professionals and anyone looking to streamline their Cloudflare DNS tasks."
              ghLink="https://youtu.be/dQw4w9WgXcQ?si=QLXZoVwZeIVbZq_p"
              demoLink="https://youtube.com/clip/Ugkx66tafQzQ2-G89tZ_U6yRV4hZe9ku1_Gs?si=GTZhyOKhmYXzN_Cw"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={portfolio}
              isBlog={false}
              title="React portfolio with live blog"
              description="This project is a personal portfolio website with a live blog section. The website is built using React, Node.js, Next.js, and Sanity. React is a popular JavaScript library for building user interfaces, while Next.js is a framework for building server-side rendered React applications. Sanity is a headless CMS that allows you to manage your content and data separately from your frontend code. The website is deployed using Cloudflare Pages and integrated with GitHub."
              ghLink="https://youtu.be/dQw4w9WgXcQ?si=QLXZoVwZeIVbZq_p"
              demoLink="cv.vsm97.cf"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
